import React from "react";
import {ShowcaseItemsView} from "./profile/Components";
import {ShowcaseItem} from "./types";
import {BaseTitleFragment} from "./BaseTitleFragment";

export class TrendingFragment extends BaseTitleFragment {

  protected getTitle(): string {
    return "Trending";
  }

  protected renderPageContent(): React.ReactElement {
    return <>
      <ShowcaseItemsView path={this.props.path} items={new Array(12).fill("_").map(val => ShowcaseItem.PLACEHOLDER)}/>
    </>;
  }
}